 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Policy
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryPolicyFilterForm">
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            v-model="filtersPolicy.polNo"
                            :label="filtersPolicyLabel.polNo"
                            :error-messages="errors.collect('filtersPolicy.polNo')"
                            data-vv-name="filtersPolicy.polNo"
                            :data-vv-as="filtersPolicyLabel.polNo"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            v-model="filtersPolicy.insdName1"
                            :label="filtersPolicyLabel.insdName1"
                            :error-messages="errors.collect('filtersPolicy.insdName1')"
                            data-vv-name="filtersPolicy.insdName1"
                            :data-vv-as="filtersPolicyLabel.insdName1"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearPolicyFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doPolicyFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="polHeaders"
          :items="polItems"
          v-bind:options.sync="paginationPolicy"
          :footer-props="{ 'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsPol"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row">
            <tr>
              <td>{{ row.item.polNo }}</td>
              <td>{{ row.item.renCnt }}</td>
              <td>{{ row.item.insdName1 }}</td>
              <td style="text-align: center">
                <v-btn icon color="primary" text type="submit" @click.prevent="assignPolicy(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import clone from 'clone'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      actionName: '',
      filtersPolicyLabel: {
        polNo: 'Policy',
        insdName1: 'Insured Name'
      },
      filtersPolicy: {
        polNo: undefined,
        insdName1: undefined
      },
      polItems: [],
      totalItemsPol: 0,
      polHeaders: [
        { text: 'Policy No.', align: 'left', value: 'polNo' },
        { text: 'Renewal Count', align: 'left', value: 'renCnt' },
        { text: 'Insured Name', align: 'left', value: 'insdName1' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationPolicy: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      panel: [0]
    }
  },
  mounted() {
    this.doClearPolicyFilters()
  },
  methods: {
    closeDialog() {
      this.filtersPolicy.polNo = undefined
      this.filtersPolicy.insdName1 = undefined
      this.$emit('close')
    },
    doClearPolicyFilters() {
      this.filtersPolicy.polNo = undefined
      this.filtersPolicy.insdName1 = undefined
      this.fetchPolicyData()
    },
    doPolicyFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryPolicyFilterForm').then((result) => {
        if (result) {
          this.paginationPolicy.page = 1
          this.fetchPolicyData()
        }
      })
    },
    async fetchPolicyData() {
      const apiUrl = this.apiURI
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationPolicy
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let messageFilters = clone(this.filtersPolicy)
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), messageFilters, this.paginationPolicy.sortBy, this.paginationPolicy.sortDesc)
          )
          if (result.data) {
            this.totalItemsPol = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.$set(this, 'polItems', data)
            } else {
              this.$set(this, 'polItems', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignPolicy(data) {
      this.$emit('assign-policy', data)
      this.$emit('close')
    }
  },
  watch: {
    paginationPolicy: function (value) {
      this.fetchPolicyData()
    }
  },
  computed: {},
  mixins: [TableConst.default, MessageMixin],
  props: {
    apiURI: String
  }
}
</script>
